import { messages } from '@nesc/shared';
import { Badge } from '@/components/ui/badge';

/** 静的リスト／条件リストの区別。条件リストは破線＝都度評価される */
export const ListTypeBadge = ({ type, size }: { type: 'static' | 'dynamic'; size?: 'default' | 'lg' }) => (
  <Badge variant={type === 'dynamic' ? 'dashed' : 'default'} size={size}>
    {type === 'dynamic' ? messages.list.typeDynamic : messages.list.typeStatic}
  </Badge>
);
